import { AuthFormModel } from './formModels'

const {
  formFields: { shippingNo, username, password, keep },
} = AuthFormModel

const initialValues = {
  [shippingNo.Name]: '',
  [username.Name]: '',
  [password.Name]: '',
  [keep.Name]: false,
}

export default initialValues
